import { defineStore } from 'pinia';

interface ActivityState {
  userGroupWxIds: string[]; // 用户所在群聊
}

// 用户信息
export const useActivityStore = defineStore({
  id: 'activity',
  state: (): ActivityState => {
    return {
      userGroupWxIds: [],
    };
  },
  getters: {},
  actions: {
    /**
     * 更新数据
     * @param data {object} 用户信息
     */
    async setUserGroupWxIds(data: string[]) {
      this.userGroupWxIds = data;
    },
  },
});
